import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess({ packing_house_id, packing_house_process_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_inspects/packing_house_process/${packing_house_id}/${packing_house_process_id}`
    );
  },
  downloadQualityInspectsRepXlsx({ container_id, packing_process_quality_template_id }) {
    return RequesterV1.get(`packing_house/quality_control/process/list_inspects/download_quality_inspects_rep_xlsx/${container_id}/${packing_process_quality_template_id}`,
      { responseType: "blob" });
  },
  fetchExportQualityInspects(harvested_batch_id, packing_process_quality_template_id) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_inspects/${harvested_batch_id}/${packing_process_quality_template_id}`
    );
  },
  fetchExporterQualityTemplate({ packing_house_id, packing_house_process_id, packing_process_quality_template_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_inspects/quality_template/${packing_house_id}/${packing_house_process_id}/${packing_process_quality_template_id}`
    );
  },
  fetchHarvestedBatch({ packing_house_id, packing_house_process_id, harvested_batch_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_inspects/harvested_batch/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}`
    );
  },
};
